var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"problem"},[_c('i',{staticClass:"el-icon-message cursor ii",on:{"click":function () { return _vm.$refs.SetoldQuession.openSetoldQuession(); }}}),_c('SetoldQuession',{ref:"SetoldQuession"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }